<template>
    <div>
        <a class="mint-cell mint-field mint-region">
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                    <span class="mint-cell-text">{{ regionLabel }}</span>
                </div>
                <div class="mint-cell-value">

                    <select  class="special-width"  v-model="oProvince" @change="changeRegion('province','oProvince')">
                        <option :value="provinceSlot.province_id" v-for="provinceSlot in provinceSlots" >{{ provinceSlot.province_name }}</option>
                    </select>

                    <select  class="special-width"   v-model="oCity" @change="changeRegion('city','oCity')">
                        <option :value="citySlot.city_id" v-for="citySlot in citySlots" >{{ citySlot.city_name }}</option>
                    </select>

                    <select  class="special-width"   v-model="oCountry" @change="changeRegion('country','oCountry')">
                        <option :value="countryslot.country_id" v-for="countryslot in countrySlots" >{{ countryslot.country_name }}</option>
                    </select>

                </div>
            </div>
            <div class="mint-cell-right"></div>
        </a>
        <a class="mint-cell mint-field mint-region">
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                    <span class="mint-cell-text"></span>
                </div>
                <div class="mint-cell-value">
                    <select class="special-width2" v-model="oTown" @change="changeRegion('town','oTown')">
                        <option :value="townSlot.town_id" v-for="townSlot in townSlots" >{{ townSlot.town_name }}</option>
                    </select>

                    <select class="special-width2" v-model="oVillage" @change="changeRegion('village','oVillage')">
                        <option :value="villageSlot.village_id" v-for="villageSlot in villageSlots" >{{ villageSlot.village_name }}</option>
                    </select>

                </div>
            </div>
            <div class="mint-cell-right"></div>
        </a>
        <a class="mint-cell mint-field mint-select">
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                    <span class="mint-cell-text"></span>
                </div>
                <div class="mint-cell-value">
                    <input  :placeholder="'请输入'+regionLabel" v-model="oAddress" @change="changeDetail" />
                </div>
            </div>
            <div class="mint-cell-right"></div>
        </a>
    </div>
</template>
<style>

</style>
<script>
    export default {
         data(){
             return {
                 openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                 showPopup:{
                     'province':false,
                     'city':false,
                     'country':false,
                     'town':false,
                     'village':false
                 },
            //     province:350,
                 provinceSlots:[],

            //     city:350200000000,
                 citySlots:[],

            //     country:350211000000,
                 countrySlots:[],

             //    town:350211001000,
                 townSlots:[],

            //     village:350211001001,
                 villageSlots:[],

            //     address:''
             }
         },

         props:{
             regionPatch:String,
             regionLabel:String,
             province:Number,
             city:Number,
             country:Number,
             town:Number,
             village:Number,
             address:String
         },

         methods:{
             showPopupFunc(type){
                 this.showPopup[type] = true;
             },

             changeRegion(type,type_props){
                 this.$axios.post("/region", {openid:this.openid,[type]:this[type_props],is_first:false})
                     .then(data => {

                         if (data.data.code === 'OK') {

                             switch (type) {
                                 case 'province':
                                     this.citySlots = data.data.data.city;
                                     this.oCity = this.citySlots[0].city_id;

                                     this.countrySlots = data.data.data.country;
                                     this.oCountry = this.countrySlots[0].country_id;

                                     this.townSlots = data.data.data.town;
                                     this.oTown = this.townSlots[0].town_id;

                                     this.villageSlots = data.data.data.village;
                                     this.oVillage = this.villageSlots[0].village_id;
                                     break;
                                 case 'city':
                                     this.countrySlots = data.data.data.country;
                                     this.oCountry = this.countrySlots[0].country_id;

                                     this.townSlots = data.data.data.town;
                                     this.oTown = this.townSlots[0].town_id;

                                     this.villageSlots = data.data.data.village;
                                     this.oVillage = this.villageSlots[0].village_id;
                                     break;
                                 case 'country':
                                     this.townSlots = data.data.data.town;
                                     this.oTown = this.townSlots[0].town_id;

                                     this.villageSlots = data.data.data.village;
                                     this.oVillage = this.villageSlots[0].village_id;
                                     break;
                                 case 'town':
                                     this.villageSlots = data.data.data.village;
                                     this.oVillage = this.villageSlots[0].village_id;
                                     break;
                             }

                             this.$emit('getAddress',[this.regionPatch,[this.oProvince,this.oCity,this.oCountry,this.oTown,this.oVillage,this.oAddress]]);
                         } else {
                             this.$toast(data.data.message);
                         }
                     });
             },

             changeDetail(){
                 this.$emit('getAddress',[this.regionPatch,[this.oProvince,this.oCity,this.oCountry,this.oTown,this.oVillage,this.oAddress]]);
             }


         },

        created(){
            this.oProvince = this.province;
            this.oCity = this.city;
            this.oCountry = this.country;
            this.oTown = this.town;
            this.oVillage = this.village;
            this.oAddress = this.address;
            this.$axios.post("/region", {openid:this.openid,province:this.province,city:this.city,country:this.country,town:this.town,is_first:true})
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.provinceSlots = data.data.data.province;
                        this.citySlots = data.data.data.city;
                        this.countrySlots = data.data.data.country;
                        this.townSlots = data.data.data.town;
                        this.villageSlots = data.data.data.village;
                    } else {
                        this.$toast(data.data.message);
                    }
                });

        },
    }
</script>
<style>
    .mint-region select{
        font-size:16px;
    }
    .special-width{
        width:32%;
    }

    .special-width2{
        width:48%;
    }
</style>



// WEBPACK FOOTER //
// src/components/region.vue